<template lang="pug">
.reply-item
  .d-flex
    v-avatar.ml-4.my-2(v-if="replyType === 'googleReview'" color="neutral300" :class="isLargerScreen ? 'mr-8' : 'mr-6' ")
      v-img(v-if="hasCompanyLogo" :src="company.logo.file" :alt="company.name")
      span.text-md.font-semibold.neutral500--text(v-else) {{ getInitial(company.name) }}
    v-avatar.ml-6.my-2.mr-4(v-else color="neutral300" size="24")
      v-img(v-if="hasCompanyLogo" :src="company.logo.file" :alt="company.name")
      span.text-xs.font-semibold.neutral500--text(v-else) {{ getInitial(company.name) }}
    
    .flex-grow-1.mt-2(:class="replyType === 'googleReview' ? 'mr-16' : 'mr-8'")
      .text-sm.font-semibold.mb-4 {{ title }}
      .form
        v-form(ref="form")
          v-textarea.text-sm.mt-2.round-xl(v-model="reply" :placeholder="placeholder" outlined hide-details="auto" :rules="rules.not_empty")  
      .d-flex.justify-end.my-4
        v-btn.button-sm.underline.mr-4(text @click="$emit('leftBtnClicked')") {{ leftBtnText }}
        v-btn.button-sm.neutral700--text(color="neutral300" :loading="rightBtnLoading" :disabled="disableRightBtn" depressed @click="$emit('rightBtnClicked', reply)") {{ rightBtnText }}
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ReplyItem',
  props: {
    title: {
      type: String,
      required: true 
    },
    placeholder: {
      type: String,
      default: '' 
    },
    rightBtnText: {
      type: String,
      required: true 
    },
    rightBtnLoading: {
      type: Boolean,
    },
    leftBtnText: {
      type: String,
      required: true 
    },
    currentReply: {
      type: String,
      default: null
    },
    replyType: {
      type: String,
      required: true,
      validator(value) {
        return ['googleReview', 'feedback'].includes(value)
      }
    }
  },
  data() {
    return {
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        below_250: [val => (val || '').length < 250 || 'Must be below than 250 characters'],
      },
      reply: ''
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    hasCompanyLogo() {
      if (this.company.logo?.file) {
        return true
      }
      return false
    },
    disableRightBtn() {
      return this.reply.length === 0
    },
    isLargerScreen() {
      return this.$vuetify.breakpoint.xl
    },
  },
  mounted () {
    if (this.currentReply) {
      this.reply = this.currentReply
    }
  },
  methods: {
    getInitial (value) {
      let name = value
      let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');
      let initials = [...name.matchAll(rgx)] || [];
      initials = ((initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')).toUpperCase();
      return initials
    }
  },
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.no-padding-x {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.selected-button {
  background: #eeeeee !important;
  border-radius: 16px;
}
::v-deep svg.v-icon.notranslate.v-data-table-header__icon {
  height: 8px !important;
  width: 8px !important;
  margin-left: 8px;
}
.file-change-layout {
  position: relative;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
</style>
